import {appLevelErrorHandler} from './error'
import {config} from '../config'

export async function post(host: string, endpoint: string, postOptions: RequestInit, body?: BodyInit | null) {
  try {
    const request = {
      method: 'POST',
      credentials: config.LOCAL_DEV ? 'include' : ('same-origin' as RequestCredentials),
      ...postOptions,
      body
    }

    const res = await fetch(`${host}${endpoint}`, request)

    if (!res.ok) {
      // TODO: Throw an error populated by the json's key, message, and forceLogOut properties
      // (see https://github.com/Ginger-Labs/Notability/pull/7181)
      throw await res.json()
    }
    return res
  } catch (err) {
    console.error('post err', err)
    // If the app-level handler does not handle the error, re-throw it.
    if (!(await appLevelErrorHandler(err))) {
      throw err
    }
  }
}

export async function postJSON(host: string, endpoint: string, postOptions: RequestInit, body?: Object) {
  const jsonBody = body ? JSON.stringify(body) : undefined
  const existingHeaders = (postOptions.headers as Record<string, string> | undefined) ?? {}
  const jsonPostOptions = {
    ...postOptions,
    headers: {
      ...existingHeaders,
      'Content-Type': 'application/json'
    }
  }

  const res = await post(host, endpoint, jsonPostOptions, jsonBody)
  return await res?.json()
}
